var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebookIcon = function SvgFacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.48,15.82H17.89V28.61H12.57V15.82H10.05V11.3h2.52V8.36C12.57,6.28,13.57,3,18,3l3.93,0V7.4H19a1.09,1.09,0,0,0-1.13,1.24V11.3h4.05l-.46,4.52",
    fill: "currentColor"
  })));
};

export default SvgFacebookIcon;